'use client'

import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import VideoModal from '@/components/wise/VideoModal'

// import 'swiper/css'
// import 'swiper/css/navigation'
// import 'swiper/css/pagination'

const PartnersTestimonials = () => {
  const [open, setOpen] = useState(false)
  const [videoUrl, setVideoUrl] = useState('')

  const testimonials = [
    {
      type: 'text',
      quote:
        "We're proud to collaborate with Medhavi University on the LEAP program—a work-integrated model enabling students to pursue higher education, gain practical skills, and earn simultaneously. It's a win-win for both students and industry.",
      name: 'Nitin Dave',
      position: 'Chief Executive Officer, Quess',
      quoteIcon:
        'https://cdn.msu.edu.in/wise-lp/icons/quote-icon.png',
      cardClass: 'testimonial_card_1',
    },
    {
      type: 'video',
      thumbnail: '/wise-lp/images/partners-img/Nitin_Dave.png',
      videoUrl: 'https://www.youtube.com/watch?v=owUyxcDOeO8',
    },
    {
      type: 'text',
      quote:
        "It's a privilege to be with Medhavi Skills University in implementing the WISE programs aimed at enhancing youth employability. Their team provides outstanding support in academics, curriculum, and assessments. Regular review meetings ensure smooth execution and continuous progress.",
      name: 'Satish Pawar',
      position: 'Director, Yuvashakti Skill India Pvt. Ltd.',
      quoteIcon: 'https://cdn.msu.edu.in/icon/qourt.webp',
      cardClass: 'testimonial_card_2',
    },
    {
      type: 'video',
      thumbnail: '/wise-lp/images/partners-img/Satish_Pawar.png',
      videoUrl: 'https://www.youtube.com/watch?v=rwN8i-Fgsz4',
    },
    {
      type: 'text',
      quote:
        "Being part of Medhavi Skills University's innovative work-integrated education model is truly rewarding. Our students have successfully completed their first semester, and we deeply value the consistent support and coordination from the Medhavi team. We feel blessed to be associated with such a visionary institution.",
      name: 'Dr. Saipriya',
      position: 'Principal, GIMSAT',
      quoteIcon:
        'https://cdn.msu.edu.in/wise-lp/icons/quote-icon.png',
      cardClass: 'testimonial_card_1',
    },
    {
      type: 'video',
      thumbnail: '/wise-lp/images/partners-img/Dr_Saipriya.png',
      videoUrl: 'https://www.youtube.com/watch?v=OiyYD_TWO20',
    },
  ]

  const openVideo = (url) => {
    setVideoUrl(url)
    setOpen(true)
  }

  const closeVideo = () => {
    setOpen(false)
    setVideoUrl('')
  }

  return (
    <>
      <section className="section_block">
        <div className="container text-center">
          <h2 className="title mb-1">Hear From Our Partners</h2>
          <p className="text-muted mb-5 paragraph">
            Discover how our partnerships are shaping success stories across industries
          </p>

          <Swiper
            modules={[Autoplay, Navigation, Pagination]}
            className="testimonial-slider overflow-hidden pt-2"
            loop
            speed={600}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            // navigation
            pagination={{ clickable: true }}
            slidesPerView={3}
            slidesPerGroup={2}
            breakpoints={{
              0: { slidesPerView: 1, slidesPerGroup: 1 },
              768: { slidesPerView: 1, slidesPerGroup: 1 },
              992: { slidesPerView: 2, slidesPerGroup: 2 },
              1200: { slidesPerView: 3, slidesPerGroup: 2 },
            }}
          >
            {testimonials.map((item, index) => (
              <SwiperSlide key={index} className="slide">
                {item.type === 'text' ? (
                  <div className={`card p-4 border-0 shadow-sm ${item.cardClass}`}>
                    <div className="d-flex justify-content-center align-items-center py-3 quote-icon">
                      <img src={item.quoteIcon} alt="quote" />
                    </div>
                    <p className="text-muted paragraph testimonial-para">{item.quote}</p>
                    <div className="d-flex flex-column">
                      <h6 className="fw-bold mt-3 mb-0">{item.name}</h6>
                      <p className="text-muted">{item.position}</p>
                    </div>
                  </div>
                ) : (
                  <div className="partner-custom-card d-flex justify-content-center align-items-center flex-column">
                    <div className="partner_img_testimonial">
                      <img className="video-bg" src={item.thumbnail} alt="Video Thumbnail" />
                    </div>

                    <button
                      type="button"
                      className="play-button"
                      onClick={() => openVideo(item.videoUrl)}
                    >
                      <img
                        className="play-btn"
                        src="https://cdn.msu.edu.in/landing-page-images/play-button.svg"
                        alt="Play Icon"
                      />
                    </button>
                  </div>
                )}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      {/* Popup modal */}
      <VideoModal open={open} videoUrl={videoUrl} onClose={closeVideo} />
    </>
  )
}

export default PartnersTestimonials